import * as React from "react";
import { useState } from "react";
import { UpDownArrow } from "./arrow";

interface ShowMoreAccordionProps {
    onClick: (isOpen: boolean) => void;
    label: string;
    labelClosed?: string;
    initialOpen?: boolean;
    className?: string;
}

export const ShowMoreAccordion = ({
    onClick,
    label,
    labelClosed,
    className = "",
    initialOpen = true
}: ShowMoreAccordionProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(initialOpen);
    return (
        <div
            className={`${className} mx-[4px] mt-4 flex w-full items-baseline justify-center p-4 text-center text-[14px] tracking-widest underline`}
            onClick={() => {
                const toBeOpened = !isOpen;
                setIsOpen(toBeOpened);
                onClick(toBeOpened);
            }}
        >
            <span className="cursor-pointer">
                {labelClosed && !isOpen ? labelClosed : label}
            </span>
            <UpDownArrow className="ml-4" headingDown={!isOpen} />
        </div>
    );
};
